import { createContext, useContext, useEffect } from "react";

/**
 * #1428 (D385, D387): which column a new-look screen sits in. Every new-look route is `"narrow"` (the 640px
 * single column) unless its screen says otherwise. An archetype slice (#1429 to #1432) calls
 * `usePageWidth("wide")` and its route takes the 1040px column; `Layout.jsx` holds the state and writes it to
 * `data-nw-width` on its `nw-shell` wrapper, which `index.css` reads. The top bar and the ribbon never change: they sit on the
 * 1040px column on every screen, so they do not jump between screens.
 *
 * Same shape as `ChromelessOverrideContext`: the default setter is a no-op, so a screen rendered outside
 * `<Layout/>` costs nothing. The screen sets it on mount and the cleanup puts it back to narrow, so two screens
 * can never leave each other's answer behind.
 */
const PageWidthContext = createContext({ setWidth: () => {} });

export const PageWidthProvider = PageWidthContext.Provider;

/** `"narrow"` (the default) or `"wide"`. Call once at the top of a screen. */
export function usePageWidth(width = "narrow") {
  const { setWidth } = useContext(PageWidthContext);
  useEffect(() => {
    setWidth(width);
    return () => setWidth("narrow");
  }, [width, setWidth]);
}
